import { defineNuxtPlugin } from '#imports'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'

import { useUpdateTrackingUserContext } from '../composables/useUpdateTrackingUserContext/useUpdateTrackingUserContext'

export default defineNuxtPlugin((nuxtApp) => {
  const userStore = useUserStore()
  const { updateTrackingUserContext } = useUpdateTrackingUserContext()

  nuxtApp.hook('app:mounted', async () => {
    if (userStore.fetched) {
      await updateTrackingUserContext()
    }
  })
})
